import { AxiosResponse } from 'axios';
import { DEFAULT_EXPIRATION_TIME } from './constants';
import BackendResponse from '@core/shared/backend-response';

/**
 * ### Request Cache Module
 * Track all register calls and cache requests.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 * @version v1
 */
export class RequestCache {
  protected urlFirstCallTime: Record<string, number> = {};
  protected urlExpirationTimes: Record<string, number> = {};
  protected cachedCalls: Record<string, AxiosResponse<BackendResponse<any>>> = {};

  protected isURLExpired(url: string): boolean {
    const now = Date.now();
    const firstCallTime = this.urlFirstCallTime[url];
    return now - firstCallTime > this.urlExpirationTimes[url];
  }

  protected isFirstCall(url: string): boolean {
    return !this.urlFirstCallTime[url];
  }

  protected getCachedCalls<T>(url: string): AxiosResponse<BackendResponse<T>> {
    return this.cachedCalls[url] as AxiosResponse<BackendResponse<T>>;
  }

  public clearCache(): void {
    this.cachedCalls = {};
    this.urlFirstCallTime = {};
    this.urlExpirationTimes = {};
  }

  public setURLExpirationTime(url: string, milliseconds: number): void {
    this.urlExpirationTimes[url] = milliseconds;
  }

  public restartURLExpirationTime(url: string): void {
    this.urlExpirationTimes[url] = DEFAULT_EXPIRATION_TIME;
  }

  public expireEnpoint(endpoint: string): void {
    for (const url of Object.keys(this.urlFirstCallTime)) {
      if (url.startsWith(endpoint)) {
        delete this.urlFirstCallTime[url];
        if (url in this.cachedCalls) delete this.cachedCalls[url];
        if (url in this.urlExpirationTimes) delete this.urlExpirationTimes[url];
      }
    }
  }
}
